import { Result } from "antd";
import React, { Component } from "react";

export class OfflinePage extends Component {
  render() {
    return (
      <div className="fullScreenCenter">
        <Result
          status="403"
          title="You're Offline"
          subTitle="Please mark yourself online"
        />
      </div>
    );
  }
}

export default OfflinePage;
